"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMiddleware = exports.corsMiddleware = exports.apiErrorMiddleware = exports.applyFetchMiddleware = void 0;
const error_1 = require("./error");
function applyFetchMiddleware(middleware, fetch) {
    let wrappedFetch = fetch;
    for (let i = middleware.length - 1; i >= 0; --i) {
        const prevHead = wrappedFetch;
        wrappedFetch = function (req) {
            return middleware[i](req, prevHead);
        };
    }
    return (...args) => {
        const request = new Request(...args);
        return wrappedFetch(request);
    };
}
exports.applyFetchMiddleware = applyFetchMiddleware;
/** Throws a DecodableApiError for any non-200 response */
function apiErrorMiddleware(request, next) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield next(request);
        if (!response.ok) {
            throw yield error_1.DecodableApiError.fromResponse(response);
        }
        return response;
    });
}
exports.apiErrorMiddleware = apiErrorMiddleware;
/** Applies the cords mode to all requests */
function corsMiddleware(req, next) {
    return __awaiter(this, void 0, void 0, function* () {
        return next(new Request(req, { mode: "cors" }));
    });
}
exports.corsMiddleware = corsMiddleware;
function authMiddleware(getAccessToken) {
    return function authMiddleware(req, next) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!req.headers.has("Authorization")) {
                req.headers.set("Authorization", `Bearer ${yield getAccessToken()}`);
            }
            return next(req);
        });
    };
}
exports.authMiddleware = authMiddleware;
